import React, { Component } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { ConnectedRouter } from 'react-router-redux';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import Menu from './components/common/Menu';
import SaldoContas from './components/home/SaldoContas';
import LoginForm from './components/autenticacao/LoginForm';
import RegistroForm from './components/autenticacao/RegistroForm';
import Contas from './components/contas/Contas';
import CCustos from './components/ccustos/CCustos';
import MovimentacaoForm from './components/movimentacao/MovimentacaoForm';
import TransferenciaForm from './components/transferencia/TransferenciaForm';
import ExtratoMensal from './components/relatorios/ExtratoMensal';
import TarefaList from './components/tarefas/TarefaList';
import Sumario from './components/graficos/Sumario';
import CcustosChart from './components/graficos/CCustos';
import ProventosChart from './components/graficos/Proventos';
import ProventosAtivosChart from './components/graficos/ProventosAtivos';
import CarteiraChart from './components/graficos/Carteira';
import Ativos from './components/ativos/Ativos';
import Carteira from './components/carteira/Carteira';
import MovAtivo from './components/MovAtivo/MovAtivo';
import Proventos from './components/proventos/Proventos';
import RFixas from './components/rfixas/RFixas';
import Pesos from './components/pesos/Pesos';
import PesosAtivos from './components/pesos/PesosAtivos';
import Posicao from './components/posicao/PosicaoConsolidada';
import ProventosAtivoAnual from './components/proventos/ProventosAtivoAnual';
import ProventosQuickAdd from './components/proventos/ProventosQuickAdd';
import ProventosUltraQuickAdd from './components/proventos/ProventosUltraQuickAdd';
import { apagarMensagem } from './redux/actions/mensagemAction';
import createHistory from 'history/createBrowserHistory';
import './App.css';
import PrivateRoute from './components/autenticacao/PrivateRoute';
import CSVMov from './components/MovAtivo/CSVMov';

const ReactToastr = require("react-toastr");
const { ToastContainer } = ReactToastr;

const history = createHistory();

class App extends Component {

	componentWillReceiveProps(nextProps) {
		if (nextProps.mensagem && nextProps.mensagem.tipo) {
			switch (nextProps.mensagem.tipo) {
				case 'yay': this.container.success(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'err': this.container.error(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'info': this.container.info(nextProps.mensagem.texto, "", { closeButton: true }); break;
				case 'warn': this.container.warning(nextProps.mensagem.texto, "", { closeButton: true }); break;
				default: this.container.warning(nextProps.mensagem.texto, "Não informou tipo correto...", { closeButton: true }); break;
			}

			this.props.apagarMensagem();
		}
	}

	checkLogin = () => {
		if (!this.props.nomeUsuario) {
			return <Redirect to="/login" />;
		}
	}

	render() {
		const ToastMessageFactory = React.createFactory(ReactToastr.ToastMessage.animation);

		return (
			<ConnectedRouter history={history}>
				<div>
					<Menu />
					<div className="container">
						<ToastContainer ref={(input) => { this.container = input; }}
							toastMessageFactory={ToastMessageFactory}
							className="toast-top-right"
							preventDuplicates />
						<PrivateRoute exact path="/" component={SaldoContas} canActivate={this.props.nomeUsuario} />
						<Route path="/login" component={LoginForm} />
						<Route path="/registro" component={RegistroForm} />
						<PrivateRoute path="/contas" component={Contas} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/ccustos" component={CCustos} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/movimentacao" component={MovimentacaoForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/movimentacao/:id" component={MovimentacaoForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/transferencia" component={TransferenciaForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/transferencia/:id" component={TransferenciaForm} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/extrato" component={ExtratoMensal} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/tarefa" component={TarefaList} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/sumario" component={Sumario} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/relCCustos" component={CcustosChart} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/relProventos" component={ProventosChart} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/relProventosAtivos" component={ProventosAtivosChart} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/relCarteira" component={CarteiraChart} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/ativos" component={Ativos} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/carteira" component={Carteira} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/posicao" component={Posicao} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/proventosAnual" component={ProventosAtivoAnual} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/movAtivo/:id" component={MovAtivo} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/movAtivo" component={MovAtivo} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/proventosQuick" component={ProventosQuickAdd} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/proventosUltraQuick" component={ProventosUltraQuickAdd} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/proventos/:id" component={Proventos} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/rfixas/:id" component={RFixas} canActivate={this.props.nomeUsuario} />
						<PrivateRoute exact path="/rfixas" component={RFixas} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/composicao" component={Pesos} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/pesos" component={PesosAtivos} canActivate={this.props.nomeUsuario} />
						<PrivateRoute path="/csv" component={CSVMov} canActivate={this.props.nomeUsuario} />
						<hr />
					</div>
					<footer className="footer text-center" style={{ color: '#777' }}>
						<img src={require('./img/cultosocultos.jpg')} height="40" width="40" alt="" />
						<p><small>Seu Barriga - Nunca mais esqueça de pagar o aluguel.</small></p>
					</footer>
				</div>
			</ConnectedRouter>
		);
	}
}

App.propTypes = {
	nomeUsuario: PropTypes.string.isRequired,
	mensagem: PropTypes.object,
	apagarMensagem: PropTypes.func.isRequired,
};

function mapStateToProps({ nomeUsuario, mensagem }) {
	return {
		nomeUsuario,
		mensagem
	};
}

function mapDispatchToProps(dispatch) {
	return {
		apagarMensagem: () => dispatch(apagarMensagem())
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/App.js